export default "__VITE_ASSET__CKhO_BNF__"